import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const AUTOMATION_TRIGGER_CATEGORIES = [
  {
    key: 'conversation',
    icon: 'chat-multiple',
    defaultEvent: 'conversation_created',
  },
  {
    key: 'call',
    icon: 'whatsapp',
    defaultEvent: 'calllog_initiated',
  },
  {
    key: 'opportunity',
    icon: 'briefcase',
    defaultEvent: 'opportunity_created',
    featureFlag: FEATURE_FLAGS.OPPORTUNITY_PIPELINES,
  },
];

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'Conversation Created',
    attributeI18nKey: 'CONVERSATION_CREATED',
    category: 'conversation',
  },
  {
    key: 'conversation_updated',
    value: 'Conversation Updated',
    attributeI18nKey: 'CONVERSATION_UPDATED',
    category: 'conversation',
  },
  {
    key: 'message_created',
    value: 'Message Created',
    attributeI18nKey: 'MESSAGE_CREATED',
    category: 'conversation',
  },
  {
    key: 'conversation_opened',
    value: 'Conversation Opened',
    attributeI18nKey: 'CONVERSATION_OPENED',
    category: 'conversation',
  },
  {
    key: 'conversation_status_changed',
    value: 'Conversation Status Changed',
    attributeI18nKey: 'CONVERSATION_STATUS_CHANGED',
    category: 'conversation',
  },
  {
    key: 'conversation_tag_updated',
    value: 'Conversation Tag Updated',
    attributeI18nKey: 'CONVERSATION_TAG_UPDATED',
    category: 'conversation',
  },
  {
    key: 'conversation_team_updated',
    value: 'Conversation Team Updated',
    attributeI18nKey: 'CONVERSATION_TEAM_UPDATED',
    category: 'conversation',
  },
  {
    key: 'conversation_agent_updated',
    value: 'Conversation Agent Updated',
    attributeI18nKey: 'CONVERSATION_AGENT_UPDATED',
    category: 'conversation',
  },
  {
    key: 'conversation_priority_updated',
    value: 'Conversation Priority Updated',
    attributeI18nKey: 'CONVERSATION_PRIORITY_UPDATED',
    category: 'conversation',
  },
  {
    key: 'calllog_initiated',
    value: 'Calllog Initiated',
    attributeI18nKey: 'CALLLOG_INITIATED',
    category: 'call',
  },
  {
    key: 'calllog_completed',
    value: 'Calllog Completed',
    attributeI18nKey: 'CALLLOG_COMPLETED',
    category: 'call',
  },
  {
    key: 'calllog_failed',
    value: 'Calllog Failed',
    attributeI18nKey: 'CALLLOG_FAILED',
    category: 'call',
  },
  {
    key: 'calllog_attended',
    value: 'Calllog Attended',
    attributeI18nKey: 'CALLLOG_ATTENDED',
    category: 'call',
  },
  {
    key: 'calllog_accept_return',
    value: 'Calllog Accept Return',
    attributeI18nKey: 'CALLLOG_ACCEPT_RETURN',
    category: 'call',
  },
  {
    key: 'event_log',
    value: 'Evento de log',
    attributeI18nKey: 'EVENT_LOG',
    category: 'conversation',
  },
  {
    key: 'opportunity_created',
    value: 'Oportunidade criada',
    attributeI18nKey: 'OPPORTUNITY_CREATED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_status_changed',
    value: 'Status da oportunidade alterado',
    attributeI18nKey: 'OPPORTUNITY_STATUS_CHANGED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_stage_changed',
    value: 'Etapa da oportunidade alterada',
    attributeI18nKey: 'OPPORTUNITY_STAGE_CHANGED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_value_changed',
    value: 'Valor da oportunidade alterado',
    attributeI18nKey: 'OPPORTUNITY_VALUE_CHANGED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_owner_changed',
    value: 'Responsável pela oportunidade alterado',
    attributeI18nKey: 'OPPORTUNITY_OWNER_CHANGED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_overdue',
    value: 'Oportunidade atrasada (fora do SLA)',
    attributeI18nKey: 'OPPORTUNITY_OVERDUE',
    category: 'opportunity',
  },
  {
    key: 'opportunity_temperature_changed',
    value: 'Temperatura da oportunidade alterada',
    attributeI18nKey: 'OPPORTUNITY_TEMPERATURE_CHANGED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_activity_created',
    value: 'Atividade criada',
    attributeI18nKey: 'OPPORTUNITY_ACTIVITY_CREATED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_activity_completed',
    value: 'Atividade concluída',
    attributeI18nKey: 'OPPORTUNITY_ACTIVITY_COMPLETED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_activity_rescheduled',
    value: 'Atividade reagendada',
    attributeI18nKey: 'OPPORTUNITY_ACTIVITY_RESCHEDULED',
    category: 'opportunity',
  },
  {
    key: 'opportunity_activity_canceled',
    value: 'Atividade cancelada',
    attributeI18nKey: 'OPPORTUNITY_ACTIVITY_CANCELED',
    category: 'opportunity',
  },
];

export const getAutomationTriggerCategory = eventName =>
  AUTOMATION_RULE_EVENTS.find(event => event.key === eventName)?.category ||
  AUTOMATION_TRIGGER_CATEGORIES[0].key;
